export const Array = {

    categoriaGastoType: [
        { id: 1, name: "EMPRESAS" },
        { id: 2, name: "PERSONA NATURAL" },
        { id: 3, name: "EMPLEADOS" },
      ]

}